import axios from "axios";
import store from "@/store";

export function fetchNotificationCount() {
    // Get values directly from store
    const teacherId = store.getters.teacherId;
    const studentId = store.getters.studentId;
    const schoolId = store.getters.schoolId;
    const userType = store.getters.userType;
    
    let id = null;
    if (teacherId) id = teacherId;
    if (studentId) id = studentId;
    if (schoolId) id = schoolId;
    if (id != null) {
        return axios.get("my/notification/count", {
            params: { id, type: userType }
        })
        .then(response => {
            store.commit("setNotificationCount", response.data);
        })
        .catch(error => {
            if (error.response && error.response.status == 401) {
                store.commit('logout');
                window.location.replace('/');
            }
            console.error(error, "error");
        });
    }
}
